import ACTION_TYPES from '../../../actions/action-types';
import { store } from '../../../store';

import { AppError } from './app-error';
import { enqueueLog } from './log-sink';

const SEVERITY_BY_KIND = {
    http: 'danger',
    network: 'danger',
    unknown: 'danger',
    validation: 'warning',
    timeout: 'info',
};

const userMessageFor = (appError) => {
    if (appError.kind === 'http' && appError.status) {
        return `Request failed (HTTP ${appError.status}). Reference id: ${appError.correlationId}`;
    }
    if (appError.kind === 'network') {
        return `Network error — please check your connection. Reference id: ${appError.correlationId}`;
    }
    if (appError.kind === 'timeout') {
        return `The request took too long and was cancelled. Reference id: ${appError.correlationId}`;
    }
    if (appError.kind === 'validation') {
        return appError.message || 'Please review your input.';
    }
    return `Something went wrong. Reference id: ${appError.correlationId}`;
};

const severityFor = (appError) =>
    SEVERITY_BY_KIND[appError.kind] || 'danger';

export const reportError = (error, context) => {
    let appError;
    try {
        appError = AppError.from(error, context);
    } catch {
        return;
    }

    try {
        store.dispatch({
            type: ACTION_TYPES.SHOW_NOTIFICATION_MESSAGE,
            payload: {
                type: severityFor(appError),
                message: userMessageFor(appError),
            },
        });
    } catch {
        // Dispatch must never propagate — surfacing this would create a loop.
    }

    try {
        // Flat-merge ctx with appError.toJSON() per the error-handling spec.
        // appError fields win on collision so the normalized error shape is authoritative.
        const ctx = context && typeof context === 'object' ? context : {};
        const entry = { ...ctx, ...appError.toJSON() };
        enqueueLog(entry);
    } catch {
        // Log forwarding is best-effort.
    }
};
